import css from 'styled-jsx/css';

const styles = css.global`.search-position {
  position: fixed;
  width: 100%;
  top: 58px;
  z-index: 9999;
  left: 0;
}

.search-results {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.search-results .search-link-url {
  position: relative;
  padding: 0;
  margin: 0;
}

.search-results .url-entry {
  min-height: 60px;
  padding: 0;
  margin: 0;
  background-color: #fff;
  display: flex;
  transition: 0.3s ease;
}

.search-results .url-entry:hover {
  background-color: #000;
}

.search-results .url-entry:hover p {
  transition: 0.3s ease;
  color: #fff;
}

.search-results .url-entry:hover img {
  filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(42deg) brightness(97%) contrast(114%);
}

.search-results .url-entry:first-of-type .url-content {
  border-top: 1px solid rgba(204, 204, 204, 0.5);
}

.search-results .url-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-height: 60px;
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);
}

.search-results a,
.search-results .url-entry p {
  color: #222;
  font-family: 'Open Sans', serif;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.search-input-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  min-height: 58px;
  padding-right: 15px;
  padding-left: 15px;
}

.search-input-container form {
  width: 100%;
  flex: 1;
}

.search-input-container input {
  font-size: 16px;
  color: #222;
  font-family: 'Open Sans', serif;

  border: none;
  box-shadow: none;
  background: none;
  outline: none;
  width: 100%;
  margin: 0;
  padding: 0;
  margin-right: 16px;
}

.search-input-container input::placeholder {
  font-size: 16px;
  color: #222;
  font-family: 'Open Sans', serif;
}

.search-mobile-icons,
.search-mobile-icons span {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
}

.search-mobile-icons span:last-of-type {
  margin-left: 36px;
}

.search-line {
  display: none;
}

.ampless-list-results {
  width: auto;
  max-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  overflow: auto;
  border: 1px solid gray;
  border-radius: 4px;
}

.ampless-list-results::-webkit-scrollbar {
  height:8px;
  width:8px
}
.ampless-list-results::-webkit-scrollbar-track {
  background-color:#fff;
  border-radius:0 4px 4px 0;
  -webkit-print-color-adjust:exact;
  print-color-adjust:exact
}
.ampless-list-results::-webkit-scrollbar-thumb {
  background-clip:padding-box;
  background-color:#ccc;
  border-radius:8px;
  border:2px solid transparent;
  -webkit-print-color-adjust:exact;
  print-color-adjust:exact
}


amp-list>div[fallback]~div {
  display: none;
}

amp-list:not(.amp-notsupported)>div[fallback]~div {
  display: block;
}

@media (min-width: 992px) {
  .search-position {
    z-index: 10000;
    top: 80px;
    width: 500px;
    left: 0;
    right: 0;
    margin-inline: auto;
  }

  .search-input-container {
    flex: 1;
    padding-right: 36px;
    padding-left: 36px;
    height: 100%;
    position: relative;
    max-width: 500px;
  }

  .search-input-container input {
    font-size: 14px;
    color: #444;
  }

  .search-input-container input::placeholder {
    font-size: 14px;
    color: #444;
  }

  .search-line {
    display: block;
    background-color: #cccccc;
    height: 3px;
    width: calc(100% - 72px);
    box-sizing: border-box;

    position: absolute;
    bottom: 0;
  }
}

.search-input-container.disable-input-container {
  display: none !important;
}

@media (min-width: 992px) {
  #search-results-position-mobile {
    display: none !important;
  }
}`;

export default styles;